import { useKeycloakAuth } from '@shared/hooks/useKeycloakAuth/index';
import { useTranslationHelper } from '@shared/hooks/useTranslationsHelper';
import styles from './DemoUserHeader.module.css';

export const DemoUserHeader = () => {
  const { logout } = useKeycloakAuth();
  const { t } = useTranslationHelper('common');

  return (
    <div className={styles['demo-banner']}>
      <div className={styles['demo-banner-content']}>
        <span className={styles['demo-banner-icon']}>i</span>
        <p className={styles['demo-banner-text']}>{t('demoUserNotice')}</p>
      </div>
      <button className={styles['demo-banner-logout']} onClick={logout} type="button">
        {t('logout')}
      </button>
    </div>
  );
};
